import React, {useEffect, useState} from 'react';
import {Box, Alert, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import RichEditor from './Shared/RichEditor';
import RichEditorResultText from './Shared/RichEditorResultText';

export const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
};

const AdditionalNotes = ({
                             index,
                             id,
                             description,
                             onChange,
                             isEditMode,
                             isFormArchived,
                             placeholderValues,
                             readOnly,
                             accessLevel,
                             audience,
                             recipientType,
                             submitMode,
                         }) => {
    const [currentValue, setCurrentValue] = useState(description ?? '');

    useEffect(() => {
        setCurrentValue(description ?? '');
    }, [description]);

    const handleDescriptionChange = (nextValue) => {
        setCurrentValue(nextValue);

        if (!onChange) return;

        onChange({
            index,
            description: stripHtmlTags(nextValue),
            formattedDescription: nextValue,
        });
    };

    return (
        <Box sx={{mt: 2}}>
            {isEditMode
                ? (
                    <Box sx={{
                        maxWidth: '52vw',
                        cursor: 'pointer'
                    }}>
                        <RichEditor
                            value={description}
                            onChange={onChange}
                            id={id}
                            index={index}
                            isEditMode={isEditMode}
                            isFormLive={isFormArchived}
                            accessLevel={accessLevel}
                            currentDescription={currentValue}
                            setCurrentDescription={handleDescriptionChange}
                            audience={audience}
                            recipientType={recipientType}
                        />
                    {currentValue && currentValue.length > 200000 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            <Typography variant="body2">
                                <strong>Warning:</strong> The description is longer than 200,000 characters (
                                {currentValue.length.toLocaleString()} characters). Such long descriptions will not be
                                included in emails - the default description will be used instead. Please reduce the
                                content or use smaller images to ensure the description is included in email
                                notifications.
                            </Typography>
                        </Alert>
                    )}
                </Box>
                )
                : (
                    <RichEditorResultText
                        id={id}
                        description={description}
                        placeholderValues={placeholderValues}
                        readonly={readOnly}
                        enableValidation={false}
                        audience={audience}
                        recipientType={recipientType}
                        submitMode={submitMode}
                    />
                )}
        </Box>
    );
};

AdditionalNotes.propTypes = {
    id: PropTypes.string,
    description: PropTypes.string,
    index: PropTypes.number,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readOnly: PropTypes.bool,
    submitMode: PropTypes.bool,
    accessLevel: PropTypes.number,
    placeholderValues: PropTypes.object,
    audience: PropTypes.number,
    recipientType: PropTypes.string,
};

export default AdditionalNotes;
